// extracted by mini-css-extract-plugin
export var button = "IUgl8";
export var detailsMessageText = "TrKke";
export var emptyStateContainer = "w1MGJ";
export var fadeIn = "aBNz3";
export var mainMessageText = "ksePc";
export var showEmptyStateContainerAnimation = "F2jxh";